import { render, staticRenderFns } from "./BedIcon.vue?vue&type=template&id=7c604a5a&"
import script from "./BedIcon.vue?vue&type=script&lang=ts&"
export * from "./BedIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports